<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="exportForm">
		<div class="grid">
			<div class="col-12 flex justify-content-center text-center bg-yellow-200 py-0 border-round-xl">
				<p-tag icon="pi cm-alert" value="{{ 'INFO_IMPORT_DEVICE' | translate }}" severity="warning"
					styleClass="text-lg"></p-tag>
			</div>
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME_LIST_DEVICE_DATAS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" formControlName="name"
							placeholder="{{ 'NAME_LIST' | translate }}" maxlength="40" [disabled]="true" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_ATLEAST_5CHARS' | translate
					}}</small>
			</div>
			<!-- <div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.description, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION_LIST' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" formControlName="description"
							placeholder="{{ 'DESCRIPTION' | translate }}" maxlength="26" [disabled]="true" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.description)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_ATLEAST_5CHARS' | translate
					}}</small>
			</div> -->
			<div class="col-12" [ngClass]="customPaddingX()">
				<ng-container formArrayName="types">
					<div class="flex justify-content-between flex-wrap"
						[ngClass]="manageRespStylewithError(this.f.types, 'borderRow')">
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.types, 'label')">{{ 'LIST_IMPORT_DATA' | translate }}
						</div>
						<div class="flex align-items-center justify-content-center"
							[ngClass]="manageRespStylewithError(this.f.types, 'borderInput')">
							<p-checkbox *ngFor="let type of exportInfo.Contents, index as count " [formControlName]="count"
								[binary]="true" label="{{ ('EXPORT_'+type.Type) | translate }}"
								[class]="showErrorRequiredCheckBox(this.f.types)" class="ml-4 mt-2"
								[class]="showErrorRequiredCheckBox(this.f.types)">
							</p-checkbox>
						</div>
					</div>
					<small *ngIf="showErrorRequiredMessage(this.f.types)" class="flex align-items-center text-50 pt-1"
						[ngClass]="justifyContentStyle()">{{ 'LIST_IMPORT_DATA_REQUIRE' | translate }}</small>
				</ng-container>
			</div>
		</div>

		<div class="grid mt-5 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'IMPORT_OVERWRITE' | translate }}"
				class="p-button-warning text-xl font-normal mx-2 mb-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2 mb-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>